import axios from "axios";
export const createPost = async (
  type,
  background,
  text,
  images,
  user,
  token,
  videos = [],
  editorialType = "facebook",
  editorialData = null
) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/createPost`,
      {
        type,
        background,
        text,
        images,
        videos,
        user,
        editorialType,
        editorialData,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    // Fallback defensivo para erros sem response (ex.: falha de rede)
    return error?.response?.data?.message || error?.message || "Erro ao criar post";
  }
};
export const reactPost = async (postId, react, token) => {
  try {
    await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/reactPost`,
      {
        postId,
        react,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return "ok";
  } catch (error) {
    return error.response.data.message;
  }
};
export const getReacts = async (postId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getReacts/${postId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
// Comentário avançado com mídia, GIF, áudio e menções
export const comment = async (postId, commentData, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/comment`,
      {
        postId,
        text: commentData.text || commentData,
        image: commentData.image,
        gif: commentData.gif,
        audio: commentData.audio,
        sticker: commentData.sticker,
        mentions: commentData.mentions,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao comentar";
  }
};

// Responder a um comentário
export const replyToComment = async (postId, commentId, replyData, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/replyToComment`,
      {
        postId,
        commentId,
        text: replyData.text,
        image: replyData.image,
        gif: replyData.gif,
        audio: replyData.audio,
        sticker: replyData.sticker,
        mentions: replyData.mentions,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao responder";
  }
};

// Reagir a um comentário
export const reactToComment = async (postId, commentId, react, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/reactToComment`,
      {
        postId,
        commentId,
        react,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao reagir";
  }
};

// Reagir a uma resposta
export const reactToReply = async (postId, commentId, replyId, react, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/reactToReply`,
      {
        postId,
        commentId,
        replyId,
        react,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao reagir";
  }
};

// Editar comentário
export const editComment = async (postId, commentId, text, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/editComment`,
      {
        postId,
        commentId,
        text,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao editar";
  }
};

// Deletar comentário
export const deleteComment = async (postId, commentId, token) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deleteComment/${postId}/${commentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao deletar";
  }
};

// Deletar resposta
export const deleteReply = async (postId, commentId, replyId, token) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deleteReply/${postId}/${commentId}/${replyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao deletar";
  }
};

// Fixar/destacar post
export const pinPost = async (postId, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/pinPost/${postId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao fixar";
  }
};

// Fixar comentário
export const pinComment = async (postId, commentId, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/pinComment`,
      {
        postId,
        commentId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response?.data?.message || "Erro ao fixar";
  }
};

// Buscar amigos para menções
export const searchMentions = async (query, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/searchMentions/${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return [];
  }
};
export const savePost = async (postId, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/savePost/${postId}`,
      {},

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};
export const deletePost = async (postId, token) => {
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/deletePost/${postId}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};

// Atualizar post existente (mantém reações e comentários)
export const updatePost = async (postId, postData, token) => {
  try {
    const { data } = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/updatePost/${postId}`,
      postData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return {
      status: "error",
      message: error.response?.data?.message || "Erro ao atualizar post"
    };
  }
};

export const sharePost = async (postId, text, token) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/sharePost`,
      {
        postId,
        text,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return { status: "ok", data };
  } catch (error) {
    return error.response.data.message;
  }
};

export const getPost = async (postId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getPost/${postId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return error.response.data.message;
  }
};

export const getPostReactions = async (postId, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getPostReactions/${postId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return { status: "error", data: [] };
  }
};

// Pesquisar posts por texto
export const searchPosts = async (searchTerm, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/searchPosts/${searchTerm}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return [];
  }
};

// Pesquisar vídeos
export const searchVideos = async (searchTerm, token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/searchVideos/${searchTerm}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return [];
  }
};

// Obter todos os vídeos
export const getAllVideos = async (token) => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/getAllVideos`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    return [];
  }
};
